import request from '@/plugins/admin_axios'

export const MountCalendar = async (data) => {
  const response = await request.post('/filial/mountCalendar/',data)
  return response.data
}

export const ListFilial = async (onlyActive = false, with_video = false, ignore_vinculo=false) => {
  const url = `/filial/list/${with_video ? 'all/' : ''}${onlyActive ? '?ativo=true': ''}${ignore_vinculo ? '&all=true' : ''}`;
  const response = await request.get(url);
  return response.data;
}

export const ListManipulacaoVagas = async (uuid_filial, data_inicial = null, data_final = null) => {
  let url = `/filial/manipulacao-vagas/list/${uuid_filial}/`
  if (data_inicial && data_final) url += `?data_inicial=${data_inicial}&data_final=${data_final}`
  const response = await request.get(url)
  return response.data
}

export const CreateManipulacaoVagas = async (data) => {
  const response = await request.post('/filial/manipulacao-vagas/save/', data)
  return response.data
}

export const DeleteManipulacaoVagas = async (id) => {
  const response = await request.delete('/filial/manipulacao-vagas/delete/', { data: { id } })
  return response.data
}

// Horários livres da agenda de uma filial em um dia (`data` no formato YYYY-MM-DD).
// Devolve só as strings `HH:MM` do primeiro (e único) dia retornado pelo backend.
export const GetHorariosAgendaFilialApi = async (filialUuid, data) => {
  const response = await request.post('/filial/getHoursToSchedule/', {
    uuid: filialUuid,
    data_inicial: data,
    data_final: data,
  })
  const horariosDoDia = Object.values(response.data?.data ?? {})?.[0]
  return Array.isArray(horariosDoDia) ? horariosDoDia.map((h) => h.horario) : []
}
